import React from "react";
import MainDashboard from "views/admin/reports";
import Profile from "views/admin/profile";
import DataTables from "views/admin/units";
import DispositivosPage from "views/admin/devices";
// import SignIn from "views/auth/SignIn";

import {
  MdHome,
  MdBarChart,
  MdPerson,
  // MdLock,
  MdSmartphone,
} from "react-icons/md";

const routes = [
  {
    name: "Unidades",
    layout: "/admin",
    path: "unidades",
    icon: <MdHome className="h-6 w-6" />,
    component: <DataTables />
  },
  {
    name: "Relatórios",
    layout: "/admin",
    path: "relatorios",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <MainDashboard />
  },
  {
    name: "Dispositivos",
    layout: "/admin",
    path: "dispositivos",
    icon: <MdSmartphone className="h-6 w-6" />,
    component: <DispositivosPage />,
  },
  {
    name: "Perfil",
    layout: "/admin",
    path: "perfil",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />
  },
  // {
  //   name: "Deslogar",
  //   layout: "/auth",
  //   path: "sign-in",
  //   icon: <MdLock className="h-6 w-6" />,
  //   component: <SignIn />,
  // },

];
export default routes;
